import { api } from '@/shared/api/client';
import type { LoginRequest, LoginResponse } from './types';

export function login(body: LoginRequest): Promise<LoginResponse> {
  return api<LoginResponse>('/api/auth/login', { method: 'POST', json: body });
}

export function logout(): Promise<void> {
  return api<void>('/api/auth/logout', { method: 'POST' });
}
